<template>
  <div>
    about Page
  </div>
</template>

<script>
export default {
  name: 'About',
  components: {}
}
</script>